import { LOCATION_CHANGE } from 'connected-react-router';
import { closePopups } from 'modules/popup/actions';

let prevPathname;
export const popupCloserMiddleware = (store) => (next) => (action) => {
  if (action.type === LOCATION_CHANGE) {
    const { payload: { isFirstRendering, location: { pathname } } } = action;

    if (isFirstRendering) {
      prevPathname = pathname;
    }
    if (!isFirstRendering && prevPathname !== pathname) {
      prevPathname = pathname;
      store.dispatch(closePopups());
    }
  }

  return next(action);
};
